import { provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { createAppConfig } from './app.config';
import { AppComponent } from './app.component';
import { initSentry } from './instrument';
import { loadWebRuntimeConfig } from './runtime-config';

// Config is fetched before bootstrap because Auth0 and the API SDK base URL are
// provider values, fixed the moment the injector is created.
loadWebRuntimeConfig()
  .then((config) => {
    initSentry(config);

    const appConfig = createAppConfig(config);

    return bootstrapApplication(AppComponent, {
      ...appConfig,
      providers: [provideZoneChangeDetection(), ...appConfig.providers],
    });
  })
  .catch((err) => {
    // Rethrow: a config fetch failure happens before Sentry.init, so the
    // unhandled rejection is the only signal that reaches the browser.
    Sentry.captureException(err);
    throw err;
  });
